export default __webpack_public_path__ + "static/banner1@2x-96945e4c348fc2e869df7077c2e88ca4.jpg";